<template>
  <TsIcon :data-testid="props.dataTestid + '-icon'" class="cursor-pointer" :name="icon" size="20" />
</template>

<script setup>
import { computed } from "vue";

const icon = computed(() => props.direction === "" ? "radix-icons:caret-sort" : props.direction === "asc" ? "dashicons:arrow-down" : "dashicons:arrow-up");
const props = defineProps({
  direction: {
    type: String,
    default: null,
  },
});
</script>
